import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import config from '../config'
import omegaAbsintheSocketLink from './OmegaAbsintheSocketLink'
import { split } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { getMainDefinition } from 'apollo-utilities'
import { setContext } from 'apollo-link-context'

// Create an http link:
const httpLink = new HttpLink({
  uri: config.omega_graphql_api
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  omegaAbsintheSocketLink,
  authLink.concat(httpLink)
)
export const omegaClient = new ApolloClient({
  link,
  cache: new InMemoryCache()
})
